export const PiBy180 = Math.PI / 180;
export const halfPI = Math.PI / 2;
